<template>
    <footer class="footer py-4 bg-white">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-4 text-lg-start">
            <span class="text-decoration-none me-3">Terminos: Pedidos con 7 días de anticipación, área de servicio
              en zona metropolitana de Morelos</span>
          </div>
          <div class="col-lg-4 my-3 my-lg-0">
            <a class="btn btn-danger btn-social mx-2" title="Pedidos por Whatsapp" 
            href="https://wa.me/5217772408608" target="_blank"
              aria-label="Whatsapp"><i class="fab fa-whatsapp"></i></a>
            <a class="btn btn-danger btn-social mx-2" title="Cotización por Facebook"
            href="https://www.fb.com/piniatas.may" target="_blank"
              aria-label="Facebook"><i class="fab fa-facebook-f"></i></a>
            <a class="btn btn-danger btn-social mx-2" title="Piñatas en Jiutepec"
             href="https://g.co/kgs/hMCzY7F" target="_blank"
              aria-label="Google"><i class="fab fa-google"></i></a>
            <a class="btn btn-danger btn-social mx-2" title="Galerías de Piñatas May"
             href="https://www.instagram.com/pinhatasmay/" target="_blank"
              aria-label="instagram de piñatas"><i class="fab fa-instagram"></i></a>
          </div>
          <div class="col-lg-4 text-lg-end">
            Created with <i class="fas fa-heart text-danger"></i> by
            <a href="https://systems-tec.web.app" rel="nofollow" title="Desarrollo de Sitios Web" class="text-dark" target="_blank">TecWeb</a>
            2025
          </div>
        </div>
      </div>
    </footer>
</template>